"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APQRCode = _interopRequireDefault(require("../../common/APQRCode/APQRCode"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _Spinner = _interopRequireDefault(require("../../common/Spinner/Spinner"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _clipboardHelper = _interopRequireDefault(require("../../../helpers/clipboardHelper"));
var _destinationTagHelper2 = _interopRequireDefault(require("../../../helpers/destinationTagHelper"));
var _APSelect = require("../../common/APSelect");
require("./ReceiveAddress.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('receive-address');
var ReceiveAddressComponent = /*#__PURE__*/function (_React$Component) {
  function ReceiveAddressComponent() {
    var _this;
    _classCallCheck(this, ReceiveAddressComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ReceiveAddressComponent, [].concat(args));
    _defineProperty(_this, "state", {
      selectedAccountProviderId: null,
      currentIndex: null
    });
    _defineProperty(_this, "handleSelectAccountProvider", function (accountProviderId) {
      var _this$props = _this.props,
        fetchAccountProviderDepositInfo = _this$props.fetchAccountProviderDepositInfo,
        product = _this$props.product;
      if (!accountProviderId) {
        return _this.setState({
          selectedAccountProviderId: accountProviderId,
          currentIndex: null
        });
      }
      fetchAccountProviderDepositInfo(product.ProductId, accountProviderId);
      _this.setState({
        selectedAccountProviderId: accountProviderId,
        currentIndex: null
      });
    });
    _defineProperty(_this, "handlePrev", function () {
      _this.setState(function (s) {
        var _s$currentIndex;
        return {
          currentIndex: Math.max(0, ((_s$currentIndex = s.currentIndex) !== null && _s$currentIndex !== void 0 ? _s$currentIndex : 0) - 1)
        };
      });
    });
    _defineProperty(_this, "handleNext", function () {
      var total = (_this.props.deposit.depositInfo || []).length;
      _this.setState(function (s) {
        var _s$currentIndex2;
        return {
          currentIndex: Math.min(total - 1, ((_s$currentIndex2 = s.currentIndex) !== null && _s$currentIndex2 !== void 0 ? _s$currentIndex2 : 0) + 1)
        };
      });
    });
    _defineProperty(_this, "handleGenerate", function () {
      var _this$props2 = _this.props,
        generateNewDepositAddress = _this$props2.generateNewDepositAddress,
        product = _this$props2.product;
      var selectedAccountProviderId = _this.state.selectedAccountProviderId;
      if (!selectedAccountProviderId) return;
      generateNewDepositAddress(product.ProductId, selectedAccountProviderId);
    });
    return _this;
  }
  _inherits(ReceiveAddressComponent, _React$Component);
  return _createClass(ReceiveAddressComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
        selectDepositProduct = _this$props3.selectDepositProduct,
        product = _this$props3.product;
      selectDepositProduct(product.ProductId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevList = prevProps.deposit && prevProps.deposit.depositInfo || [];
      var nextList = this.props.deposit && this.props.deposit.depositInfo || [];
      if (nextList.length && nextList.length !== prevList.length) {
        // Initial load (0 → N) lands on the first/oldest;
        // Generate (N → N+1) lands on the new last.
        var targetIndex = prevList.length === 0 ? 0 : nextList.length - 1;
        this.setState({
          currentIndex: targetIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props4 = this.props,
        addressList = _this$props4.deposit.depositInfo,
        _this$props4$deposit = _this$props4.deposit,
        isLoading = _this$props4$deposit.isLoading,
        error = _this$props4$deposit.error,
        templateTypes = _this$props4$deposit.templateTypes,
        product = _this$props4.product,
        showSnack = _this$props4.showSnack,
        WalletsDisabledMessage = _this$props4.WalletsDisabledMessage;
      var _this$state = this.state,
        selectedAccountProviderId = _this$state.selectedAccountProviderId,
        currentIndex = _this$state.currentIndex;

      // Protocol prefix for the QR Code, lowercase name with no spaces.
      var depositType = product.ProductFullName.toLowerCase().replace(/\W/g, '');
      var templateTypeOptions = [{
        value: '',
        label: 'Select an option',
        disabled: true,
        selected: true
      }].concat(_toConsumableArray(templateTypes.map(function (template) {
        return {
          value: template.AccountProviderId,
          label: template.AccountProviderName
        };
      })));
      var list = Array.isArray(addressList) ? addressList : [];
      var total = list.length;
      var safeIndex = total ? Math.min(Math.max(currentIndex !== null && currentIndex !== void 0 ? currentIndex : 0, 0), total - 1) : null;
      var selectedAddress = !isLoading && safeIndex !== null ? list[safeIndex] : undefined;
      var atFirst = total <= 1 || safeIndex === 0;
      var atLast = total <= 1 || safeIndex === total - 1;
      var _destinationTagHelper = (0, _destinationTagHelper2["default"])(selectedAddress),
        address = _destinationTagHelper.address,
        dt = _destinationTagHelper.dt,
        memo = _destinationTagHelper.memo,
        note = _destinationTagHelper.note;
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses()
      }, templateTypes.length ? /*#__PURE__*/_react["default"].createElement(_APSelect.InnerSelect, {
        name: "AccountProvider",
        customClass: bemClasses('account-provider-select'),
        label: t('Select an option to continue the deposit process'),
        onSelect: this.handleSelectAccountProvider,
        options: templateTypeOptions
      }) : /*#__PURE__*/_react["default"].createElement("div", null, t('No account providers are configured')), selectedAccountProviderId && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, selectedAddress && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('description')
      }, t('Scan this QR code to receive funds:')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('qr-code')
      }, /*#__PURE__*/_react["default"].createElement(_APQRCode["default"], {
        value: "".concat(depositType, ":").concat(selectedAddress)
      })), /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('copy-address-text')
      }, t('Or copy this address:')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('copy-address-payload'),
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(address);
          showSnack({
            id: 'RECEIVE_ADDRESS_COPY',
            text: t('The address has been copied to the clipboard.')
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('address')
      }, address), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: bemClasses('copy-icon')
      })), dt && /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(dt);
          showSnack({
            id: 'RECEIVE_ADDRESS_COPY',
            text: t('The destination tag has been copied to the clipboard.')
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('destination-tag-text')
      }, t('Be sure to include this destination tag:')), /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('address')
      }, dt), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: bemClasses('copy-icon')
      })), memo && /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(memo);
          showSnack({
            id: 'RECEIVE_ADDRESS_COPY',
            text: t('The memo tag has been copied to the clipboard.')
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('tag-text')
      }, t('Be sure to include this memo tag:')), /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('address')
      }, memo), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: bemClasses('copy-icon')
      })), note && /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(note);
          showSnack({
            id: 'RECEIVE_ADDRESS_COPY',
            text: t('The note tag has been copied to the clipboard.')
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('tag-text')
      }, t('Be sure to include this note tag:')), /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('address')
      }, note), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: bemClasses('copy-icon')
      })), total > 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('pager')
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.handlePrev,
        disabled: atFirst,
        className: bemClasses('pager-button', atFirst ? 'disabled' : ''),
        "aria-label": t('Previous address')
      }, "\u2039"), /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('pager-counter')
      }, "".concat(safeIndex + 1, " / ").concat(total)), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.handleNext,
        disabled: atLast,
        className: bemClasses('pager-button', atLast ? 'disabled' : ''),
        "aria-label": t('Next address')
      }, "\u203A"))), !error && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.handleGenerate,
        disabled: isLoading,
        className: bemClasses('generate-button')
      }, t('Generate new address'))), isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        text: t('Loading url...'),
        customClass: bemClasses
      }), WalletsDisabledMessage ? /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('error')
      }, t(WalletsDisabledMessage)) : error && /*#__PURE__*/_react["default"].createElement("span", {
        className: bemClasses('error')
      }, t(error)));
    }
  }]);
}(_react["default"].Component);
ReceiveAddressComponent.defaultProps = {
  deposit: {
    templateInfo: {},
    templateTypes: [],
    template: {},
    isLoading: false,
    error: '',
    depositInfo: [],
    depositStatus: {}
  },
  product: {}
};
ReceiveAddressComponent.propTypes = {
  product: _propTypes["default"].object,
  deposit: _propTypes["default"].shape({
    templateInfo: _propTypes["default"].object,
    templateTypes: _propTypes["default"].array,
    template: _propTypes["default"].object,
    isLoading: _propTypes["default"].bool,
    error: _propTypes["default"].string,
    product: _propTypes["default"].number,
    depositInfo: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
    depositStatus: _propTypes["default"].shape({
      success: _propTypes["default"].bool,
      RequestCode: _propTypes["default"].string
    })
  }),
  selectDepositProduct: _propTypes["default"].func.isRequired,
  fetchAccountProviderDepositInfo: _propTypes["default"].func.isRequired,
  generateNewDepositAddress: _propTypes["default"].func.isRequired,
  showSnack: _propTypes["default"].func.isRequired,
  WalletsDisabledMessage: _propTypes["default"].string
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('send')(ReceiveAddressComponent);